import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const DocumentMinusIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/document-minus"><path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M5.39998 1.6001C4.40586 1.6001 3.59998 2.40589 3.59998 3.4V20.6C3.59998 21.5941 4.40586 22.4 5.39998 22.4H18.6C19.5941 22.4 20.4 21.5941 20.4 20.6V8.35C20.4 7.87261 20.2103 7.40757 19.8728 7.07L14.9272 2.13C14.5896 1.79243 14.1318 1.6001 13.6544 1.6001H5.39998ZM14.7 14.1C15.197 14.1 15.6 13.6971 15.6 13.2C15.6 12.7029 15.197 12.3 14.7 12.3H9.29997C8.80292 12.3 8.39997 12.7029 8.39997 13.2C8.39997 13.6971 8.80292 14.1 9.29997 14.1H14.7Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default DocumentMinusIcon;